import { ApolloClients, getMidgardPath } from "./ApolloClients";

const midgardService = getMidgardPath();
export const midgardClients = new ApolloClients(midgardService);
